type Action = { type: 'set'; key: string; value: number } | { type: 'delete'; key: string } | { type: 'clear' }

export const measurementMapReducer = (state: Map<string, number>, action: Action) => {
  switch (action.type) {
    case 'set': {
      if (state.has(action.key) && state.get(action.key) === action.value) {
        return state
      }
      const nextState = new Map(state)
      nextState.set(action.key, action.value)
      return nextState
    }
    case 'delete': {
      if (!state.has(action.key)) {
        return state
      }
      const nextState = new Map(state)
      nextState.delete(action.key)
      return nextState
    }
    case 'clear': {
      if (0 === state.size) {
        return state
      }
      return new Map()
    }
    default: {
      return state
    }
  }
}
